import { render, staticRenderFns } from "./CountrySummaryModal.vue?vue&type=template&id=00967308"
import script from "./CountrySummaryModal.vue?vue&type=script&lang=js"
export * from "./CountrySummaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports